import _objectSpread from "/Users/dave/tg_usdt_monitor/telegram_admin_template/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _variables from '@/styles/variables.scss';
import { mapGetters } from 'vuex';
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['appInfo'])), {}, {
    variables: function variables() {
      return _variables;
    }
  })
};